// ADR-0034 §2 P5 — Stable block id (uuidv7 inject)
//
// Tiptap 의 BlockId extension 이 본 helper 를 사용해 새 block 에 uuidv7 inject.
// 기존 block 의 `_id` 는 보존 (revision 간 정합).

import { uuidv7 } from "uuidv7";

import type { Block } from "./block";

/**
 * Block 에 stable id 주입.
 * 이미 `_id` 있는 block 은 그대로, 없으면 uuidv7 생성. recursive (innerBlocks).
 */
export function ensureStableIds(block: Omit<Block, "_id"> & { _id?: string }): Block {
  return {
    ...block,
    _id: block._id ?? uuidv7(),
    innerBlocks: (block.innerBlocks ?? []).map((inner) =>
      ensureStableIds(inner as Omit<Block, "_id"> & { _id?: string }),
    ),
  };
}

/**
 * 한 번에 block tree 전체에 stable id 주입.
 * import 또는 새 post 생성 시 entrypoint.
 */
export function injectStableIdsTree(blocks: readonly (Omit<Block, "_id"> & { _id?: string })[]): Block[] {
  return blocks.map((b) => ensureStableIds(b));
}
